import { formatDistanceToNow } from 'date-fns';
import { ko } from 'date-fns/locale';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Outlet, useParams } from 'react-router-dom';
import { NotFoundPage } from 'routes/NotFoundPage';
import { CountryNav } from './CountryNav';
import { countryTextMap } from 'routes/Util/Util.helper';
import { useMeta } from 'components/Footer/Footer.hooks';
import { Share } from 'components/Icons';
import Button from 'react-bootstrap/Button';
import { useShare } from 'components/Share/Share.hooks';

export type ContryCodeType = 'US' | 'KR';

export type ContryContextType = {
  countryCode: ContryCodeType;
};

export const CountryPage = () => {
  const { countryCode } = useParams<{ countryCode: ContryCodeType }>();
  const { data: metaStocks } = useMeta();
  const onShareClick = useShare();

  const lastUpdated = metaStocks?.data()?.lastUpdated;

  if (!countryCode || !['US', 'KR'].includes(countryCode)) {
    return <NotFoundPage />;
  }

  return (
    <Container>
      <Row>
        <Col className="d-flex align-items-end justify-content-between">
          <h2 className="mb-0">{countryTextMap[countryCode]}</h2>
          <div className="d-flex align-items-center">
            {lastUpdated && (
              <small className="text-muted">
                업데이트:{' '}
                {formatDistanceToNow(lastUpdated, {
                  locale: ko,
                  addSuffix: true,
                })}
              </small>
            )}
            <span className="mx-2">&middot;</span>
            <Button variant="link" className="p-0" onClick={onShareClick}>
              <Share />
            </Button>
          </div>
        </Col>
      </Row>
      <Row className="d-flex align-items-center">
        <Col>
          <CountryNav />
        </Col>
      </Row>
      <Outlet context={{ countryCode }} />
    </Container>
  );
};
